import axios from 'axios'

export default class SystemRepository { 
  static getVersionInfo() { 
    return axios.get('info/build')
  }
}